import { gql } from "@apollo/client";

export const FIND_DIVISION_DEPENDENCY_MATRIX = gql`
  query FindDivisionDependencyMatrix($division: UUIDInput!, $level: Int!, $location: UUIDInput, $parentLocation: UUIDInput) {
    findDivisionDependencyMatrix(division: $division, level: $level, location: $location, parentLocation: $parentLocation) {
      division {
        locationAuxs {
          uuid
          supportedRevenue
          percentage
          name
        }
      }
    }
  }
`